import * as Sentry from '@sentry/react';

import { DEV } from '@shared/config/env';
import { createLogger } from '@shared/lib/logger';
import {
  createModalHost,
  createReduxModalStackStore,
  type ModalErrorLogger,
  type ModalErrorReporter,
} from '@shared/lib/modal';

import { store } from '@app/store';

import { modalComponentRegistry } from './modalComponentRegistry';

const logger = createLogger('ModalHost');

const logModalError: ModalErrorLogger = (message, error) => logger.error(message, error);

const reportModalErrorToSentry: ModalErrorReporter = (error, context) => {
  Sentry.captureException(error, {
    tags: { modalReason: context.reason, modalType: context.modalType },
    extra: { modalId: context.modalId, source: context.source },
  });
};

export const appModalHost = createModalHost({
  stackStore: createReduxModalStackStore(store),
  isDev: Boolean(DEV),
  reportError: reportModalErrorToSentry,
  logError: logModalError,
});

appModalHost.registry.registerMany(modalComponentRegistry);

import.meta.hot?.dispose(() => appModalHost.dispose());
